export enum ConfigPermissionEnum
{
  // ------------------------------------------------------------------------------------------------------------------
  // Global Config

  User = 1,

  AdminRoles = 2,

  ProjectRoles = 3,

  UserStructureRoles = 4,

  // ------------------------------------------------------------------------------------------------------------------

  DatabaseConfigurations = 5,

  Structure = 6,

  StructureCategories = 7,

  Craft = 8,

  Company = 9,

  FieldNames = 10,

  Status = 11,

  Delay = 12,

  Classification1 = 13,

  Classification2 = 14,

  Classification3 = 15,

  Classification4 = 16,

  CostCategory = 17,

  // ------------------------------------------------------------------------------------------------------------------

  DocumentType = 18,

  WritingTemplate = 19,

  WritingTemplateStructure = 20,

  ReportTemplate = 21,

  ChartTemplate = 22,

  // ------------------------------------------------------------------------------------------------------------------

  EmailConfigurations = 23,

  EmailTemplates = 24,

  EmailDistributors = 25,

  EmailRules = 26,

  EmailRuleAssignment = 27,

  // ------------------------------------------------------------------------------------------------------------------

  VariablesGlobal = 28,

  VariablesProject = 29,

  VariablesUser = 30,

  VariablesWriting = 31,

  // ------------------------------------------------------------------------------------------------------------------
  // Project Config

  ProjectInformation = 32,

  ProjectConfiguration = 33,

  ProjectStructure = 34,

  ProjectCraft = 35,

  ProjectCompany = 36,

  ProjectFieldNames = 37,

  ProjectWritingTemplate = 38,

  ProjectVariables = 39,

  ProjectStructureAddresses = 40,

  ProjectUserDefined1 = 41,

  ProjectUserDefined2 = 42,

  ProjectPlan = 54,

  ProjectAttachment = 55,


  // ------------------------------------------------------------------------------------------------------------------
  // User

  UserVariable = 43,

  UserSetting = 44,
}
